import { cx } from "../lib/cx";

/**
 * 알림 배너 — 원본 `app.css` 의 `.alert` 계열.
 *
 * `role="status"` 를 붙이는 이유: 작업 결과(저장·삭제·권한 없음)를 화면 갱신과 함께 조용히
 * 바꾸면 스크린리더 사용자는 아무 일도 일어나지 않은 것처럼 느낍니다. 긴급하지 않은 안내라
 * `alert` 가 아니라 `status`(polite) 입니다.
 */

export type FlashKind = "ok" | "error" | "warn";

export interface Flash {
  kind: FlashKind;
  text: string;
}

const KIND: Record<FlashKind, string> = {
  error: "border-[#ffd4d4] bg-red-100 text-[#a31a1a]",
  ok: "border-[#c9efd9] bg-[#eefbf3] text-[#0a7a43]",
  warn: "border-[#ffe3c2] bg-[#fff6eb] text-[#a65400]",
};

export function Alert({ kind, children }: { kind: FlashKind; children: string }) {
  return (
    <div
      role="status"
      className={cx(
        "mb-[20px] flex items-start gap-[10px] rounded-xl border px-[16px] py-[14px] text-[14px]",
        KIND[kind],
      )}
    >
      {children}
    </div>
  );
}
